import { render, staticRenderFns } from "./addTemporaryModal.vue?vue&type=template&id=2b1a24c8&scoped=true&"
import script from "./addTemporaryModal.vue?vue&type=script&lang=js&"
export * from "./addTemporaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a24c8",
  null
  
)

export default component.exports